import { get } from 'lodash'
import { mapGetters } from 'vuex'
import { success } from '@/utils/alert'

export default {
  ...mapGetters(['userIsCompany']),
  getRouterIndex () {
    return this.prefixRouter + '.edit'
  },
  isEdit () {
    if (get(this.$route, 'query.first', false)) {
      success('Perfil criado com sucesso, aproveite para finalizar seu cadastro.')
    }
    return 'me'
  },
  isCreate () {
    return false
  },
  country_register () {
    if (!this.company.document) {
      if (!this.userIsCompany) {
        return 'CPF'
      }
      return 'CNPJ'
    }
    return (get(this.company, 'document', '').length > 11) ? 'CNPJ' : 'CPF'
  }
}



// WEBPACK FOOTER //
// ./src/app/professional/company/companies/form/resources/computed.js